import React from "react";
import {
    Box,
    Heading,
    Text,
    VStack,
    Button,
    useColorModeValue,
    chakra
} from "@chakra-ui/react";

import { Header as Nav } from "../header/Header";
import { Footer } from "../footer/Footer";
import {useEvoContext} from "../../context/evo.context";
import {useNavigate} from "react-router-dom";
import {ROUTE_LOGIN, ROUTE_MAIN, ROUTE_PROFILE} from "../../App";
import {ScreenContainer} from "../container/ScreenContainer";

export const SubscriptionActivated = ({showTitle = true, showHeading = true}) => {

    return (
        <Box
            bg={useColorModeValue('#f9f9f9', '#1a202c')}
            height="100vh"
            justifyContent="center"
            alignItems="center"
        >
            <Nav />
            <ScreenContainer pb={"350px"}>
            {showTitle && (<chakra.h1
                textAlign={'center'}
                fontSize={'4xl'}
                py={10}
                fontWeight={'bold'}
            >
                Předplatné úspěšně aktivováno!
            </chakra.h1>)}

            <Box
                width="100%"
                maxW="800px"
                mx="auto"
                bg="white"
                borderRadius="lg"
                padding={10}
                boxShadow="md"
            >
                <VStack spacing={6} textAlign="center">
                    {showHeading && (<Heading as="h2" fontSize="2xl" color="green.500">
                        {"Děkujeme za aktivaci vašeho předplatného."}
                    </Heading>)}

                   <SubscriptionActivatedContent />
                </VStack>
            </Box>
            </ScreenContainer>
            <Footer />
        </Box>
    );
};

export const SubscriptionActivatedContent = (newAccountInfo = false) => {
    const {isLoggedIn} = useEvoContext();
    const navigate = useNavigate();

    return (
       <>
           {isLoggedIn && (<>
               <Text fontSize="lg">
                   Časopisy naleznete ve vašem profilu.
               </Text>
               <Button
                   size="md"
                   colorScheme="pink"
                   onClick={() => navigate(ROUTE_MAIN + ROUTE_PROFILE)}
               >
                   {"Přejít na můj profil"}
               </Button>
           </>)}

           {!isLoggedIn && (<>
               <Text fontSize="lg">
                   Časopisy naleznete ve vašem profilu po přihlášení.
               </Text>

               {newAccountInfo && (<Text fontSize="lg">Instrukce pro aktivaci vašeho účtu jsme odeslali na Váš e-mail.</Text>)}

               <Button
                   size="md"
                   colorScheme="pink"
                   onClick={() => navigate(ROUTE_MAIN + ROUTE_LOGIN)}
               >{"Přihlásit se"}
               </Button>
           </>)}
       </>
    );
}
